export default function RedeemTabIcon({ img }: { img: string }): JSX.Element {
    return <img src={img} alt="redeem-tab-icon" style={{
        width: "100%"
    }}/>;
}
